exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * There are two approaches you can use to write your Less/CSS.\n * The first is to namespace your sub-component inside the top-level component's class name.\n * This will help avoid class name collisions with the host application.\n * It does however, increase selectivity.\n *\n * We also highly recommend you use the BEM methodology for your components.\n * When utilized correctly, it can reduce the amount nested selectors required for your app.\n * For more info, see: http://getbem.com\n */\n", ""]);

// exports
